import Rule from './rule';

export default class TrimRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
      this.ruleType = 'TRIM';
  }
  run(input) {
      return input.trim()
  }
}
